import { render, staticRenderFns } from "./CreatePermiso.vue?vue&type=template&id=5e14081e&"
import script from "./CreatePermiso.vue?vue&type=script&lang=js&"
export * from "./CreatePermiso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports